import {
  UPDATE_MEMBER_VERIFY_LOADING,
  UPDATE_MEMBER_VERIFY_PHONE,
  UPDATE_MEMBER_VERIFY_REQUEST,
  UPDATE_MEMBER_VERIFY_REQUEST_FORM
} from "../actions/types"

const initialState = {
  loading: false,
  phone: null,
  requestSaveData: {
    otp: "",
    errorMessage: "",
    status: 0,
    referenceCode: "",
    statusAPIValidate: 0,
    verifyType: "phone"
  },
  otpData: {
    otpId: "",
    otcId: "4d8db0e5-59c5-48f6-bade-f60e084e7a8d",
    result: null,
    errorCount: true,
    exprCode: true
  }
}

const memberVerify = (state = initialState, action) => {
  const { type, payload } = action

  switch (type) {
    case UPDATE_MEMBER_VERIFY_LOADING:
      return {
        ...state,
        loading: payload
      }
    case UPDATE_MEMBER_VERIFY_PHONE:
      return {
        ...state,
        phone: payload
      }
    case UPDATE_MEMBER_VERIFY_REQUEST:
      return {
        ...state,
        requestSaveData: {
          ...state.requestSaveData,
          [payload.name]: payload.value
        }
      }
    case UPDATE_MEMBER_VERIFY_REQUEST_FORM:
      return {
        ...state,
        otpData: {
          ...state.otpData,
          otpId: payload.otpId,
          result: payload.result,
          errorCount: payload.errorCount,
          exprCode: payload.exprCode
        }
      }
    default:
      return state
  }
}

export default memberVerify